import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import Themes from "./themes";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";

axios.defaults.withCredentials = true;

ReactDOM.render(
    <ThemeProvider theme={Themes.default}>
        <CssBaseline />
        <App />
    </ThemeProvider>,
    document.getElementById("root")
);

serviceWorker.unregister();
